import '../css/bootstrap.css';
import '../css/footer.css';
import { FaFacebook } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";





export default function Rodape (){
  return (
    
    <div className="text-center text-lg-start bg-light rounded h1" id="rodape">
    
    <section
    className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom"
    >
    
    <div className="me-5 d-none d-lg-block">
    <span>Get connected with us on social networks:</span>
    </div>
    
    <div>
    <FaFacebook />
    <FaTwitter />
    <FaGoogle />
    <FaInstagram />
    <FaLinkedin />
    <FaGithub />
    </div>
    
    </section>
    
    <section className="">
    <div className="container text-center text-md-start mt-5">
    
    <div className="row mt-3">
    
    <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
    
    <h6 className="text-uppercase fw-bold mb-4">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="36" fill="currentColor" className="bi bi-gem" viewBox="0 0 16 16">
    <path d="M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6l3-4zm11.386 3.785-1.806-2.41-.776 2.413 2.582-.003zm-3.633.004.961-2.989H4.186l.963 2.995 5.704-.006zM5.47 5.495 8 13.366l2.532-7.876-5.062.005zm-1.371-.999-.78-2.422-1.818 2.425 2.598-.003zM1.499 5.5l5.113 6.817-2.192-6.82L1.5 5.5zm7.889 6.817 5.123-6.83-2.928.002-2.195 6.828z"/>
    </svg>
    Um tesouro, seu tesouro!
    </h6>
    
    </div>
    
    
    <div className="text-center p-1">
    © 2021 Copyright:
    <a className="text-reset fw-bold" href="https://github.com/renanjansen" >Renan Jansen</a>
    </div>
    
    </div>
    </div>
    </section>
    </div>
    
    
    );
};